import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-147627ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed acon-gradient update-screen" }
const _hoisted_2 = { class: "flex justify-center flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-8 text-center" }, " We are optimizing your app experience. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MovingLayersLogo = _resolveComponent("MovingLayersLogo")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MovingLayersLogo),
      _hoisted_3,
      _createVNode(_component_ion_spinner, {
        name: "dots",
        duration: "1000",
        class: "inline-block m-auto mt-2"
      })
    ])
  ]))
}